import React from "react";

function ChevronRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="12"
      fill="currentColor"
      viewBox="0 0 8 12"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.064 11.648a1.2 1.2 0 010-1.696L5.016 6 1.064 2.048A1.2 1.2 0 012.761.352l4.8 4.8a1.2 1.2 0 010 1.696l-4.8 4.8a1.2 1.2 0 01-1.697 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default ChevronRight;
